import { z } from "zod";
import { ENDING_RARITY_VALUES } from "../../constants/ending-rarity.js";
import { PLAYTHROUGH_STATUS_VALUES } from "../../constants/playthrough-status.js";
export const PlaythroughHistoryItemSchema = z.object({
    id: z.uuid(),
    storyId: z.uuid(),
    storyTitle: z.string(),
    storyCoverUrl: z.url(),
    status: z.enum(PLAYTHROUGH_STATUS_VALUES),
    endingName: z.string().nullable(),
    endingRarity: z.enum(ENDING_RARITY_VALUES).nullable(),
    completedAt: z.string().nullable(),
    startedAt: z.string(),
});
